import React, { Component } from 'react';
import { Helmet } from 'react-helmet';
import headerBar from '../modules/headerBar';
import footer from '../modules/footer';
import productHistory from '../modules/productHistory';
// images
import productHistoryBanner from '../images/productHistoryBanner.png'


class ProductHistoryPageComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  render() {
  	return (
	    <div id="page-productHistory">
      <Helmet>
        <title>鄧師傅功夫菜-食材履歷</title>
        <meta name="description" content="飄香高雄35載，滷豬腳年銷售超越50座臺北101大樓高度! 馳名海內外，獲得媒體一致推薦。Chef Teng founded in 1984, Taiwan, is famous for signature stewed pork knuckles and has won awards and recognition from news media around the world." />
      </Helmet>
        <headerBar.container/>

        {/* <div className="ProductHistoryTitle">
          <p className="center">食材履歷</p>
        </div>  */}
        <div className="row TitleBox">
          <p className="col-auto mr-auto Title">食材履歷</p>
          <p className="col-auto DirectionTitle">首頁 / 食材履歷</p>
        </div>

        <productHistory.container/>

        <footer.container/>
	    </div>
	  )
  }
}

export default ProductHistoryPageComponent;
